<template>
  <section>
    <!--工具条-->
    <DictionaryToolbar :buttonList="buttonList" @callFunction="callFunction"></DictionaryToolbar>

    <!--列表-->
    <el-table
      :data="dictionary"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      @selection-change="handleSelectionChange"
      row-key="Id"
      border
      lazy
      ref="table"
      :load="loadChildren"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      style="width: 100%;"
    >
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="DictName" label="字典名称" width="200" sortable></el-table-column>
      <el-table-column prop="DictCode" label="字典代码" width="200" sortable></el-table-column>
      <el-table-column prop="OrderSort" label="排序" width="150" sortable></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime" width="200" sortable></el-table-column>
      <el-table-column prop="Enabled" label="状态" width="200" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled  ? 'success' : 'danger'"
            disable-transitions
          >{{scope.row.Enabled ? "正常":"禁用"}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="200">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--查看界面-->
    <el-dialog
      title="查看"
      :visible.sync="lookUpFormVisible"
      v-model="lookUpFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="lookUpForm" label-width="80px" ref="lookUpForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="字典名称" prop="DictName" label-width="110px">
              <el-input v-model="lookUpForm.DictName" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="字典代码" prop="DictCode" label-width="110px">
              <el-input v-model="lookUpForm.DictCode" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="排序" prop="OrderSort" label-width="110px">
              <el-input v-model="lookUpForm.OrderSort" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="状态" prop="Enabled" label-width="110px">
              <el-select v-model="lookUpForm.Enabled" disabled placeholder="请选择车辆状态">
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="lookUpFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="字典名称" prop="DictName" label-width="110px">
              <el-input v-model="editForm.DictName" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="字典代码" prop="DictCode" label-width="110px">
              <el-input v-model="editForm.DictCode" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="排序" prop="OrderSort" label-width="110px">
              <el-input-number v-number-only v-model="editForm.OrderSort" :min="0" :max="1000" style="width:187px" ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="状态" prop="Enabled" label-width="110px">
              <el-select v-model="editForm.Enabled" placeholder="请选择车辆状态">
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="字典名称" prop="DictName" label-width="110px">
              <el-input v-model="addForm.DictName" />
            </el-form-item>
          </el-col>
           <el-col :span="10" style="float:right;">
            <el-form-item label="字典代码" prop="DictCode" label-width="110px">
              <el-input v-model="addForm.DictCode" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
           <el-form-item label="排序" prop="OrderSort" label-width="110px">
              <el-input-number v-number-only v-model="addForm.OrderSort" :min="0" :max="1000" style="width:187px" ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="状态" prop="Enabled" label-width="110px">
              <el-select v-model="addForm.Enabled" placeholder="请选择字典状态">
                <el-option label="激活" value="true"></el-option>
                <el-option label="禁用" value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getTreeTableListPage, addDictionary, editDictionary, removeDictionary,verifyDictNameExist,verifyDictCodeExist } from "../../api/api";
import { getButtonList,getOperationButtonList } from "../../promissionRouter";
import DictionaryToolbar from "../../components/QueryToolbar/DictionaryToolbar";

export default {
  components: { DictionaryToolbar },
  data() {
    let addDictNameCheck = (rule, value, callback) => {
      if (value != "") {
        this.dictNameRules(0,this.addForm.Pid,value,callback);
      }
    };
    let editDictNameCheck = (rule, value, callback) => {
      if (value != "") {
        this.dictNameRules(this.editForm.Id,this.editForm.Pid,value,callback);
      }
    };
    let addDictCodeCheck = (rule, value, callback) => {
      if (value != "") {
        this.dictCodeRules(0,this.addForm.Pid,value,callback);
      }
    };
    let editDictCodeCheck = (rule, value, callback) => {
      if (value != "") {
        this.dictCodeRules(this.editForm.Id,this.editForm.Pid,value,callback);
      }
    };
    return {
      filters: {
        dictName: "",
        dictCode: ""
      },
      maps: new Map(),
      buttonList: [],
      operationButtonList: [],
      dictionary: [], //字典列表
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false }
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      lookUpFormVisible: false, //查看界面是否显示
      //查看界面数据
      lookUpForm: {
        Id: 0,
        CreateBy: "",
        Pid: 0,
        Enabled: false,
        DictName: "",
        DictCode: "",
        OrderSort: 0
      },
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        DictName: [{ required: true, message: "请输入字典名称", trigger: "blur" },{ validator: editDictNameCheck, trigger: "blur" }],
        DictCode: [{ required: true, message: "请输入字典代码", trigger: "blur" },{ validator: editDictCodeCheck, trigger: "blur" }]
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CreateBy: "",
        Pid: 0,
        Enabled: false,
        DictName: "",
        DictCode: "",
        OrderSort: 0
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        DictName: [{ required: true, message: "请输入字典名称", trigger: "blur" },{ validator: addDictNameCheck, trigger: "blur" }],
        DictCode: [{ required: true, message: "请输入字典代码", trigger: "blur" },{ validator: addDictCodeCheck, trigger: "blur" }]
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        Pid: 0,
        Enabled: "true",
        DictName: "",
        DictCode: "",
        OrderSort: 0
      },
      multipleSelection: []
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        dictName: item.dictName,
        dictCode: item.dictCode
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item,row){
      this.currentRow = row;
      this[item.Func].apply(this,item);
    },
    //性别显示转换
    formatEnabled: function(row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function(row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getDictionary();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getDictionary();
    },
    queryDictionary(){
      this.page = 1;
      this.getDictionary();
    },
    loadChildren(tree,treeNode,resolve) {
      // 将当前选中节点数据存储到maps
      this.maps.set(tree.Id,{tree,treeNode,resolve});
      let para = {
        dictName: this.filters.dictName,
        dictCode: this.filters.dictCode,
        page: 1,
        pageSize: 100,
        f: tree.Id  
      };
      getTreeTableListPage(para).then(res => {
        resolve(res.data.response.data);
      });
    },
    refreshLoadTree(parentId){
      if(parentId !== undefined && parentId>0){
        if(this.maps.has(parentId)){
          const {tree,treeNode,resolve} = this.maps.get(parentId);
          this.$set(this.$refs.table.store.states.lazyTreeNodeMap, parentId, [])
          if(tree !== undefined && tree){
            this.loadChildren(tree,treeNode,resolve);
          }
        }
      }
    },
    //获取字典列表
    getDictionary() {
      let _this = this;
      let para = {
        dictName: _this.filters.dictName,
        dictCode: _this.filters.dictCode,
        page: _this.page,
        pageSize: _this.pageSize,
      };
      _this.listLoading = true;
      getTreeTableListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.dictionary = res.data.response.data;
        _this.listLoading = false;
      });
    },
    //校验字典名称是否已经存在
    dictNameRules(id,pid,value,callback) {
      let para = {
        dictName: value,
        id:id,
        pid:pid
      };
      verifyDictNameExist(para).then(res => {
        if(res.data){
          callback(new Error("字典名称已存在，请重新输入"));
        }
        callback();
      });
    },
    //校验字典代码是否已经存在
    dictCodeRules(id,pid,value,callback) {
      let para = {
        dictCode: value,
        id:id,
        pid:pid
      };
      verifyDictCodeExist(para).then(res => {
        if(res.data){
          callback(new Error("字典代码已存在，请重新输入"));
        }
        callback();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
      .then(() => {
        this.listLoading = true;
        let para = { id: row.Id };
        removeDictionary(para).then(res => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }

          this.getDictionary();
          this.refreshLoadTree(row.Pid);
        });
      })
      .catch(() => {});
    },
    //显示查看界面
    handleLookUp() {
      this.lookUpFormVisible = true;
      this.lookUpForm = Object.assign({}, this.currentRow);
    },
    //显示编辑界面
    handleEdit() {
      this.editFormVisible = true;
      this.editForm = Object.assign({}, this.currentRow);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: "",
        CompanyName: "",
        Enabled: "true",
        Pid:0
      };
    },
    //显示新增界面
    handleChildrenAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: "",
        CompanyName: "",
        Enabled: "true",
        Pid: this.currentRow.Id,
        PPid: this.currentRow.Pid
      };
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let para = Object.assign({}, this.editForm);

            editDictionary(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getDictionary();
                this.refreshLoadTree(this.editForm.Pid);
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addDictionary(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getDictionary();
                if(this.addForm.PPid !== undefined && this.addForm.PPid>0){
                  this.refreshLoadTree(this.addForm.PPid);
                }
                this.refreshLoadTree(this.addForm.Pid);
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  },
  mounted() {
    this.getDictionary();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>

</style>
